import u from "jquery";

class Base {
  constructor(wrapper) {
    this.wrapper = u(wrapper);
  }
  run() {
  }

  stop() {
    clearInterval(this.interval);
    this.wrapper.html('');
  }
}
export { Base };
